export const DEFAULT_EMPTY_LABEL = '';
export const DEFAULT_NULL_VALUE = '--';

export const DEFAULT_DOCUMENT_TYPE = 'document';
export const INBOX_EMAIL_TYPE = 'thread';
export const STATUSES = {
  NEW: 'new',
  OPEN: 'open',
  CLOSED: 'closed',
};

export const ELLIPSIS_CLASS = 'cloudcfo-ellipsis';
export const UPLOAD_SOURCES = {
  LIBRARY: 'library',
  LOCAL: 'local',
};

// NOTE: this supports old message histories that uses tailwindcss
export const MESSAGE_HISTORY_TW_SUPPORT_STYLE = `
  * { border: 0; }
  .tw-text-cfo-black { color: #414A4F; }
  .tw-text-\\[14px\\] { font-size: 14px; }
  .tw-border-solid { border-style: solid; }
  .tw-border-l-\\[1px\\] { border-left-width: 1px; }
  .tw-border-cfo-grey-500 { border-color: #eeeeee; }
  .tw-p-\\[10px\\] { padding: 10px }
`;

export const INLINE_IMAGE_DATA_ATTRIBUTE = 'data-img-filename';
